export default __webpack_public_path__ + "images/cbabe0a295b32f0a619f1d6c69ea72fd.png";